import { path } from "d3";
import { defineAsyncComponent } from "vue";
import { createRouter, createWebHistory } from "vue-router";

const Maintenance = defineAsyncComponent(() =>
  import("../views/maintenance/Maintenance.vue")
);

//rmsons
const Home = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-home" */ "../views/home/Home.vue")
);

// const Game = defineAsyncComponent(() => import(/* webpackChunkName: "group-game" */ "../views/game/Game.vue"));
// const Preorder = defineAsyncComponent(() => import(/* webpackChunkName: "group-preorder" */ "../views/game/PreOrders.vue"));
// const Package = defineAsyncComponent(() => import(/* webpackChunkName: "group-package" */ "../views/package/Package"));
// const PackagePreorder = defineAsyncComponent(() => import(/* webpackChunkName: "group-packagePreorder" */ "../views/package/PreOrders"));
// const Payment = defineAsyncComponent(() => import(/* webpackChunkName: "group-Payment" */ "../views/payment/Payment"));
// const Terms = defineAsyncComponent(() => import(/* webpackChunkName: "group-Terms" */ "../views/payment/step/Terms.vue"));
// const Registration = defineAsyncComponent(() => import(/* webpackChunkName: "group-Registration" */ "../views/users/Registration.vue"));
const Login = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-Login" */ "../views/users/Login.vue")
);
const LoginPath = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-LoginPath" */ "../views/users/LoginPath.vue"
  )
);
// const Thankyou = defineAsyncComponent(() => import(/* webpackChunkName: "group-Thankyou" */ "../views/payment/step/Thankyou.vue"));
// const CardThankyou = defineAsyncComponent(() => import(/* webpackChunkName: "group-CardThankyou" */ "../views/card/steps/Thankyou.vue"));
// const Card = defineAsyncComponent(() => import(/* webpackChunkName: "group-Card" */ "../views/card/Card.vue"));
// const GiftCard = defineAsyncComponent(() => import(/* webpackChunkName: "group-GiftCard" */ "../views/card/GiftCard.vue"));
// const CardPackage = defineAsyncComponent(() => import(/* webpackChunkName: "group-CardPackage" */ "../views/card/Detail.vue"));
// const CardTerms = defineAsyncComponent(() => import(/* webpackChunkName: "group-CardTerms" */ "../views/card/steps/Term.vue"));
// const CardPayment = defineAsyncComponent(() => import(/* webpackChunkName: "group-CardPayment" */ "../views/card/steps/Payment.vue"));
// const Coin = defineAsyncComponent(() => import(/* webpackChunkName: "group-Coin" */ "../views/coin/History.vue"));
// const Subscription = defineAsyncComponent(() => import(/* webpackChunkName: "group-page" */ "../views/subscription/Subscription.vue"));
// const SubscripTerms = defineAsyncComponent(() => import(/* webpackChunkName: "group-Subscription" */ "../views/subscription/steps/Term.vue"));
// const SubscripPayment = defineAsyncComponent(() => import(/* webpackChunkName: "group-SubscripPayment" */ "../views/subscription/steps/Payment.vue"));
// const Annoucement = defineAsyncComponent(() => import(/* webpackChunkName: "group-Annoucement" */ "../views/reward/Announce.vue"));
// const Redeem = defineAsyncComponent(() => import(/* webpackChunkName: "group-Redeem" */ "../views/reward/Redeem.vue"));
// const CollectHistory = defineAsyncComponent(() => import(/* webpackChunkName: "group-CollectHistory" */ "../views/reward/CollectHistory.vue"));

// Management
const GameManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/stock/Game.vue"
  )
);
const CustomDropdown = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/stock/CustomDropdown.vue"
  )
);
const CustomDropdownDetail = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/stock/CustomDropdownDetail.vue"
  )
);
const PackageManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/stock/Package.vue"
  )
);
const UserManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/user/User.vue"
  )
);
const UserDetail = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/user/UserDetail.vue"
  )
);
const UserAttachment = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/user/Attachment.vue"
  )
);
const GenerateLinkSignIn = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/user/GenerateLinkSignIn.vue"
  )
);
const CustomerProfile = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/customer/CustomerProfile.vue"
  )
);
const AppConfig = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/app/AppConfig.vue"
  )
);
const WalletManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/wallet/Wallet.vue"
  )
);
const RemainingWalletManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/wallet/Remain.vue"
  )
);
const RandomBonusManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/randombonus/RandomBonus.vue"
  )
);
const ResetOtp = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/user/Otp.vue"
  )
);
const PlayerManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/user/Player.vue"
  )
);
const Recommend = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/product/Recommend.vue"
  )
);
const GameCrossProduct = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/product/GameCrossProduct.vue"
  )
);
const CardCrossProduct = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/product/CardCrossProduct.vue"
  )
);

const WalletDetailManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/wallet/Details.vue"
  )
);
const ManagePurchaseHistory = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/purchase/PurchaseHistory.vue"
  )
);

const AgentManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/agent/Agent.vue"
  )
);
const BenefitGameTopup = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/agent/BenefitGameTopup.vue"
  )
);
const BenefitCashCard = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/agent/BenefitCashCard.vue"
  )
);
const BankStatement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/bank/BankStatement.vue"
  )
);
const StockCard = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/stock/Card.vue"
  )
);
const StockGiftVoucher = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/stock/GiftVoucher.vue"
  )
);

const StockCardDetail = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/stock/CardDetail.vue"
  )
);

const MessageManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/app/Message.vue"
  )
);
const MessageLineManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/app/MessageLine.vue"
  )
);
const GameContentManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/content/ContentDetails.vue"
  )
);
const PromoteContentManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/content/PromoteContent.vue"
  )
);
const BonusContentManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/content/BonusContent.vue"
  )
);
const CouponPremiumConfigManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/content/CouponPremiumConfig.vue"
  )
);

const ReviewManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/review/Review.vue"
  )
);
const CouponManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/coupon/Coupon.vue"
  )
);
const CouponHistory = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/coupon/History.vue"
  )
);

const CoinDetailsManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/coin/Details.vue"
  )
);
const CoinManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/coin/Coin.vue"
  )
);
const CoinHistory = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/coin/History.vue"
  )
);

const Campaign = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/luckycoin/Campaign.vue"
  )
);
const RichmanCoinPremium = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/luckycoin/RichmanPremium.vue"
  )
);
const RichmanCoinPremiumHistory = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/luckycoin/RichmanPremiumHistory.vue"
  )
);
const RewardManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/luckycoin/Reward.vue"
  )
);
const LuckyCoinManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/luckycoin/Coin.vue"
  )
);
const ManageLuckyCoinHistory = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/luckycoin/History.vue"
  )
);
const CampaignBanner = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/luckycoin/CampaignBanner.vue"
  )
);

const Announced = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/announced/Announce.vue"
  )
);

const FlashSaleManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/flashsale/FlashSaleConfig.vue"
  )
);
const FlashSale = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/flashsale/FlashSale.vue"
  )
);
const FlashSaleHistory = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/flashsale/FlashSaleHistory.vue"
  )
);

const AffiliateManagement = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-management" */ "../views/management/affiliate/LinkAffiliate.vue"
  )
);

const CouponRedemption = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-couponredemption" */ "../views/management/coupon_redemption/CouponRedemption.vue"
  )
);

const SummarizePrice = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-summarizeprice" */ "../views/management/sale_summarize/SaleSummarizeView.vue"
  )
);

const RichmanCoinDashboardView = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-richmancoinDashboard" */ "../views/management/richmancoin_dashboard/RichmanCoinDashboardView.vue"
  )
);

const MonthlyRichmanCoinDashboardView = defineAsyncComponent(() =>
  import(
      /* webpackChunkName: "group-MonthlyRichmanCoinDashboardView" */ "../views/management/richmancoin_dashboard/MonthRichmanCoinDashboardView.vue"
    )
);

const DailyCardSaleDashboardView = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-DailyCardSaleDashboardView" */ "../views/management/card_sale_dashboard/DailyCardSaleDashboardView.vue"
  )
);

const FreeOrderDashboardView = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-FreeOrderDashboardView" */ "../views/management/free_order_dashboard/FreeOrderDashboardView.vue"
  )
);

// Order
const PurchaseDetails = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/purchase/PurchaseDetails.vue"
  )
);
const CardDetails = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/purchase/CardDetails.vue"
  )
);
const PurchaseHistory = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/purchase/PurchaseHistory.vue"
  )
);
const SaleDashboard = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/dashboard/SaleDashboard.vue"
  )
);
const StockDashboard = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/dashboard/StockDashboard.vue"
  )
);

const AgentPerformance = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/report/AgentPerformance.vue"
  )
);
const CoinsPerformance = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/report/CoinsPerformance.vue"
  )
);
const CouponPerformance = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/report/CouponPerformance.vue"
  )
);
const Affiliateformance = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-order" */ "../views/report/AffiliatePerformance.vue"
  )
);

const SignIdDashboard = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-SignIdDashboard" */ "../views/report/PathSignIn.vue"
  )
);
const DashboardLayout = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-DashboardLayout" */ "../views/dashboard/layout/DashboardLayout.vue"
  )
);

// Wallet
const Wallet = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-wallet" */ "../views/wallet/Wallet.vue")
);

// Page Headers
const DefaultHeader = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-Headers" */ "../views/dashboard/headers/DefaultHeader"
  )
);

// footer
const HomeFooter = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-footer" */ "../views/dashboard/layout/HomeFooter"
  )
);

const AuthLayout = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-Layout" */ "../views/dashboard/pages/AuthLayout.vue"
  )
);

//Policy
const AboutUs = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-Policy" */ "../views/policy/Aboutus.vue")
);
const Contect = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-Policy" */ "../views/policy/Contect.vue")
);
const PrivacyPolicy = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-Policy" */ "../views/policy/Privacy.vue")
);
const ReturnPolicy = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-Policy" */ "../views/policy/Return.vue")
);

// logs
const AticityLogs = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-order" */ "../views/logs/AticityLogs.vue")
);

const CodaValidateLogs = defineAsyncComponent(() =>
  import(/* webpackChunkName: "group-order" */ "../views/logs/CodaValidateLogs.vue")
);
//Customize
const Customize = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "group-home" */ "../views/customize/HomeCustomize.vue"
  )
);


const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/home",
    name: "Dashboard",
    children: [
      {
        path: "home",
        name:
          "RichMan Shop ผู้ให้บริการด้านเกม Online (เปิดบริการตลอด 24 ชั่วโมง)",
        components: {
          default: Home,
          header: DefaultHeader,
          homefooter: HomeFooter,
        },
      },
      {
        path: "/customize",
        name: "Home Customize",
        components: { default: Customize, header: DefaultHeader },
      },
      // {
      //   path: "termgame",
      //   name: "เติมเกมออนไลน์สุดคุ้ม",
      //   title: "เติมเกมออนไลน์สุดคุ้ม",
      //   components: { default: Game, header: DefaultHeader },
      // },
      // {
      //   path: "preorder",
      //   name: "Pre-order Game Top-up",
      //   title: "เติมเกมออนไลน์สุดคุ้ม",
      //   components: { default: Preorder, header: DefaultHeader },
      // },
      // {
      //   path: "subscription",
      //   name: "SUBSCRIPTION",
      //   title: "SUBSCRIPTION",
      //   components: { default: Subscription, header: DefaultHeader },
      // },
      // {
      //   path: "subscription/terms",
      //   name: "Subscription Terms",
      //   components: { default: SubscripTerms, header: DefaultHeader },
      // },
      // {
      //   path: "subscription/payment",
      //   name: "Subscription Payment",
      //   components: { default: SubscripPayment, header: DefaultHeader },
      // },
      // {
      //   path: "game/:code",
      //   name: "Package Choose",
      //   props: true,
      //   components: { default: Package, header: DefaultHeader },
      // },
      // {
      //   path: "preorder/:code",
      //   name: "Package Pre-order Choose",
      //   props: true,
      //   components: { default: PackagePreorder, header: DefaultHeader },
      // },
      // {
      //   path: "payment",
      //   name: "Payment",
      //   components: { default: Payment, header: DefaultHeader },
      // },
      // {
      //   path: "terms",
      //   name: "Terms",
      //   components: { default: Terms, header: DefaultHeader },
      // },
      // {
      //   path: "registration",
      //   name: "Registration",
      //   components: { default: Registration, header: DefaultHeader },
      // },
      {
        path: "login",
        name: "Login",
        components: { default: Login, header: DefaultHeader },
      },
      {
        path: "login/:name?",
        name: "Login",
        components: { default: LoginPath, header: DefaultHeader },
      },
      // {
      //   path: "thankyou",
      //   name: "Thank you",
      //   components: { default: Thankyou, header: DefaultHeader },
      // },
      // {
      //   path: "giftcard/thankyou",
      //   name: "Card Thank you",
      //   components: { default: CardThankyou, header: DefaultHeader },
      // },
      // {
      //   path: "giftcard",
      //   name: "บัตรเติมเกมออนไลน์สุดคุ้ม",
      //   components: { default: GiftCard, header: DefaultHeader },
      // },
      // {
      //   path: "card",
      //   name: "บัตรเติมเกมออนไลน์สุดคุ้ม สำหรับ Agent",
      //   components: { default: Card, header: DefaultHeader },
      // },
      // {
      //   path: "giftcard/:slug/:id",
      //   name: "Card Package Choose",
      //   props: true,
      //   components: { default: CardPackage, header: DefaultHeader },
      // },
      // {
      //   path: "giftcard/terms",
      //   name: "Card Terms",
      //   components: { default: CardTerms, header: DefaultHeader },
      // },
      // {
      //   path: "giftcard/payment",
      //   name: "Card Payment",
      //   components: { default: CardPayment, header: DefaultHeader },
      // },
      // {
      //   path: "coin",
      //   name: "ริชแมนคอยน์",
      //   components: { default: Coin, header: DefaultHeader },
      // },
      // {
      //   path: "announce",
      //   name: "Annoucement",
      //   components: { default: Annoucement, header: DefaultHeader },
      // },
      // {
      //   path: "redeem",
      //   name: "แลกของรางวัล",
      //   components: { default: Redeem, header: DefaultHeader },
      // },
      // {
      //   path: "collect/history",
      //   name: "ประวัติการสะสมแต้ม",
      //   components: { default: CollectHistory, header: DefaultHeader },
      // },
      // {
      //   path: "flashsale",
      //   name: "Flash Sale",
      //   components: { default: FlashSale, header: DefaultHeader },
      // },
      {
        path: "management/game",
        name: "Game Package Management",
        components: { default: GameManagement, header: DefaultHeader },
      },
      {
        path: "management/customdropdown",
        name: "Custom Dropdown Management",
        components: { default: CustomDropdown, header: DefaultHeader },
      },
      {
        path: "management/customdropdown/:id",
        name: "Custom Dropdown Detail Management",
        components: { default: CustomDropdownDetail, header: DefaultHeader },
      },
      {
        path: "management/package/:id",
        name: "Package Stock Management",
        components: { default: PackageManagement, header: DefaultHeader },
      },
      {
        path: "management/user",
        name: "User Management",
        components: { default: UserManagement, header: DefaultHeader },
      },
      {
        path: "user/:id",
        name: "User Details",
        components: { default: UserDetail, header: DefaultHeader },
      },
      {
        path: "management/userattachment",
        name: "User Attachment",
        components: { default: UserAttachment, header: DefaultHeader },
      },
      {
        path: "management/player",
        name: "Player Management",
        components: { default: PlayerManagement, header: DefaultHeader },
      },
      {
        path: "management/linksignin",
        name: "User GenerateLinkSignIn",
        components: { default: GenerateLinkSignIn, header: DefaultHeader },
      },
      {
        path: "management/customer",
        name: "Customer Profile",
        components: { default: CustomerProfile, header: DefaultHeader },
      },
      {
        path: "management/recommend",
        name: "Recommend",
        components: { default: Recommend, header: DefaultHeader },
      },
      {
        path: "management/cossproduct/game/:id",
        name: "Game CrossProduct Management",
        components: { default: GameCrossProduct, header: DefaultHeader },
      },
      {
        path: "management/cossproduct/card/:id",
        name: "Card CrossProduct Management",
        components: { default: CardCrossProduct, header: DefaultHeader },
      },
      {
        path: "management/appconfig",
        name: "App Config",
        components: { default: AppConfig, header: DefaultHeader },
      },
      {
        path: "management/wallet",
        name: "Wallet Management",
        components: { default: WalletManagement, header: DefaultHeader },
      },
      {
        path: "management/remainingwallet",
        name: "Remaining wallet Management",
        components: {
          default: RemainingWalletManagement,
          header: DefaultHeader,
        },
      },
      {
        path: "management/wallet/:uid",
        name: "Wallet Management Detail",
        components: { default: WalletDetailManagement, header: DefaultHeader },
      },
      {
        path: "management/coin/history",
        name: "Coin History",
        components: { default: CoinHistory, header: DefaultHeader },
      },
      {
        path: "management/coin/setup",
        name: "Coin Management",
        components: { default: CoinManagement, header: DefaultHeader },
      },
      {
        path: "management/randombonus",
        name: "Random Bonus Management",
        components: { default: RandomBonusManagement, header: DefaultHeader },
      },
      {
        path: "purchase/history",
        name: "ประวัติการสั่งซื้อของฉัน",
        title: "ประวัติการสั่งซื้อของฉัน",
        components: { default: PurchaseHistory, header: DefaultHeader },
      },
      {
        path: "management/history",
        name: "Management Purchase History",
        components: { default: ManagePurchaseHistory, header: DefaultHeader },
      },
      {
        path: "purchase/details/:id",
        name: "Purchase Details",
        components: { default: PurchaseDetails, header: DefaultHeader },
      },
      {
        path: "management/details/:id",
        name: "Management Purchase Details",
        components: { default: PurchaseDetails, header: DefaultHeader },
      },
      {
        path: "management/card/:id",
        name: "Management Card Details",
        components: { default: CardDetails, header: DefaultHeader },
      },
      {
        path: "purchase/giftcard/:id",
        name: "Card Details",
        components: { default: CardDetails, header: DefaultHeader },
      },
      {
        path: "dashboard/sale",
        name: "Sales Dashboard",
        components: { default: SaleDashboard, header: DefaultHeader },
      },
      {
        path: "dashboard/stock",
        name: "Stock Dashboard",
        components: { default: StockDashboard, header: DefaultHeader },
      },
      {
        path: "dashboard/usersignin",
        name: "Signin Dashboard",
        components: { default: SignIdDashboard, header: DefaultHeader },
      },
      {
        path: "wallet",
        name: "My Point",
        title: "My Point",
        components: { default: Wallet, header: DefaultHeader },
      },
      {
        path: "management/agent",
        name: "Agent Management",
        components: { default: AgentManagement, header: DefaultHeader },
      },
      {
        path: "management/benefitgametopup",
        name: "Agent Discount - Top Up",
        components: { default: BenefitGameTopup, header: DefaultHeader },
      },
      {
        path: "management/benefitcashcard",
        name: "Agent Discount - Cash Card",
        components: { default: BenefitCashCard, header: DefaultHeader },
      },
      {
        path: "management/bankstatement",
        name: "Bank Statement Management",
        components: { default: BankStatement, header: DefaultHeader },
      },
      {
        path: "management/stock/card",
        name: "Card stock Management",
        components: { default: StockCard, header: DefaultHeader },
      },
      {
        path: "management/stock/giftvoucher",
        name: "Giftvoucher stock Management",
        components: { default: StockGiftVoucher, header: DefaultHeader },
      },
      {
        path: "management/stock/card/:id",
        name: "Card detail Management",
        components: { default: StockCardDetail, header: DefaultHeader },
      },
      {
        path: "management/message",
        name: "Message Management",
        components: { default: MessageManagement, header: DefaultHeader },
      },
      {
        path: "management/messageline",
        name: "Message Line Management",
        components: { default: MessageLineManagement, header: DefaultHeader },
      },
      {
        path: "management/couponpremiumconfig",
        name: "Coupon Premium Config",
        components: { default: CouponPremiumConfigManagement, header: DefaultHeader },
      },
      {
        path: "report/agentperformance",
        name: "Agent Performance Report",
        components: { default: AgentPerformance, header: DefaultHeader },
      },
      {
        path: "report/coinsperformance",
        name: "Coins Performance Report",
        components: { default: CoinsPerformance, header: DefaultHeader },
      },
      {
        path: "report/couponperformance",
        name: "Coupon Performance Report",
        components: { default: CouponPerformance, header: DefaultHeader },
      },
      {
        path: "report/affiliateformance",
        name: "Affiliate Coupon Performance Report",
        components: { default: Affiliateformance, header: DefaultHeader },
      },
      {
        path: "management/content",
        name: "Content Management",
        components: { default: GameContentManagement, header: DefaultHeader },
      },
      {
        path: "management/promotecontent",
        name: "PromoteContent Management",
        components: { default: PromoteContentManagement, header: DefaultHeader },
      },
      {
        path: "management/Bonuscontent",
        name: "BonusContent Management",
        components: { default: BonusContentManagement, header: DefaultHeader },
      },
      {
        path: "management/review",
        name: "Review Management",
        components: { default: ReviewManagement, header: DefaultHeader },
      },
      {
        path: "management/coupon",
        name: "Coupon Management",
        components: { default: CouponManagement, header: DefaultHeader },
      },
      {
        path: "management/coupon/history",
        name: "Coupon History",
        components: { default: CouponHistory, header: DefaultHeader },
      },
      {
        path: "management/otp",
        name: "OTP Logs Management",
        components: { default: ResetOtp, header: DefaultHeader },
      },
      {
        path: "privacy",
        name: "Privacy Policy",
        components: { default: PrivacyPolicy, header: DefaultHeader },
      },
      {
        path: "return",
        name: "RETURN POLICY",
        components: { default: ReturnPolicy, header: DefaultHeader },
      },
      {
        path: "aboutus",
        name: "About Us",
        components: { default: AboutUs, header: DefaultHeader },
      },
      {
        path: "contectus",
        name: "Contect Us",
        components: { default: Contect, header: DefaultHeader },
      },
      {
        path: "management/campaign",
        name: "Campaign Management",
        components: { default: Campaign, header: DefaultHeader },
      },
      {
        path: "management/richmancoinPremium",
        name: "RichmanCoin Premium Management",
        components: { default: RichmanCoinPremium, header: DefaultHeader },
      },
      {
        path: "management/richmancoinHistory",
        name: "RichmanCoin Premium History",
        components: { default: RichmanCoinPremiumHistory, header: DefaultHeader },
      },
      {
        path: "management/reward/:id",
        name: "Reward Management",
        components: { default: RewardManagement, header: DefaultHeader },
      },
      {
        path: "management/luckycoin/:id",
        name: "Lucky Coin Management",
        components: { default: LuckyCoinManagement, header: DefaultHeader },
      },
      {
        path: "management/luckycoin/history",
        name: "Lucky Coin History",
        components: { default: ManageLuckyCoinHistory, header: DefaultHeader },
      },
      {
        path: "management/campaign/banner/:id",
        name: "Campaign Banner",
        components: { default: CampaignBanner, header: DefaultHeader },
      },
      {
        path: "management/announced",
        name: "Announced Reward",
        components: { default: Announced, header: DefaultHeader },
      },
      {
        path: "management/coin/:uid",
        name: "Point Management Detail",
        components: { default: CoinDetailsManagement, header: DefaultHeader },
      },
      {
        path: "management/flashsale",
        name: "Flash Sale Management",
        components: { default: FlashSaleManagement, header: DefaultHeader },
      },
      {
        path: "management/flashsalehistory",
        name: "Flash Sale History",
        components: { default: FlashSaleHistory, header: DefaultHeader },
      },
      {
        path: "management/affiliate",
        name: "Link Affiliate Management",
        components: { default: AffiliateManagement, header: DefaultHeader },
      },
      {
        path: "log/activity",
        name: "Aticity Logs",
        components: { default: AticityLogs, header: DefaultHeader },
      },
      {
        path: "log/codavalidate",
        name: "Coda Validate Logs",
        components: { default: CodaValidateLogs, header: DefaultHeader },
      },
      {
        path: "management/coupon-redemption",
        name: "Coupon Redemption",
        components: { default: CouponRedemption, header: DefaultHeader },
      },
      {
        path: "management/summarizeprice",
        name: "Sale Summarize Price",
        components: { default: SummarizePrice, header: DefaultHeader },
      },
      {
        path: "management/richmancoin-dashboard",
        name: "RichmanCoin Dashboard",
        components: { default: RichmanCoinDashboardView, header: DefaultHeader },
      },
      {
        path: "management/monthly-richmancoin-dashboard",
        name: "Monthly RichmanCoin Dashboard",
        components: { default: MonthlyRichmanCoinDashboardView, header: DefaultHeader },
      },
      {
        path: "management/daily-cardsale-dashboard",
        name: "Daily Card Sale Dashboard",
        components: { default: DailyCardSaleDashboardView, header: DefaultHeader },
      },
      {
        path: "management/free-order-dashboard",
        name: "Free Order Dashboard",
        components: { default: FreeOrderDashboardView, header: DefaultHeader },
      }
    ],
  },
  {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
      {
        path: "/maintenance",
        name: "Maintenance",
        components: { default: Maintenance, header: DefaultHeader },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/home",
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
    return { x: 0, y: 0 }; // Go to the top of the page if no hash
  },
  routes,
});

router.beforeEach((to, from, next) => {
  document.title =
    "เติมเกม เติมเกมมือถือ บริการเติมเกม เติมเกมราคาถูก pubg freefire rov valorant ragnarok | Richman Shop";
  next();
});

export default router;
